angular
  .module('vppApp').run(['$state', '$rootScope', '$stateParams', '$location', '$injector', '$log', '$window', 'AuthenticationService', '$timeout', 'vppConfig', 'ProgramInfoService', 'PageInfoService', 'DTMTrackerService', '$anchorScroll', 'TimeOutService', 'ScrollToService', 'VarientService', 'SetLiveSwapService', 'ServerNodeStore', '$cookies', function ($state, $rootScope, $stateParams, $location, $injector, $log, $window, AuthenticationService, $timeout, vppConfig, ProgramInfoService, PageInfoService, DTMTrackerService, $anchorScroll, TimeOutService, ScrollToService, VarientService, SetLiveSwapService, ServerNodeStore, $cookies) {
    $state.transitionTo('index');
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.basePath = httpBasePath;
    $rootScope.hasSSOCookie = false;
    //        var lastDigestRun = Date.now();
    //        var idleCheck = $interval(function () {
    //          console.log("idleCheck");
    //
    //          var now = Date.now();
    //          //if (now - lastDigestRun > 30*60*1000) {
    //          if (now - lastDigestRun > 10000) {
    //            // logout
    //            console.log("Log OUT ~~~~~~ " + " : " + now + " : " + lastDigestRun);
    //            $interval.cancel(idleCheck);
    //          }
    //          // }, 60*1000);
    //        }, 5000);

    // hack to scroll to top when navigating to new URLS but not back/forward
    var wrap = function (method) {
      var orig = $window.window.history[method];
      $window.window.history[method] = function () {
        var retval = orig.apply(this, Array.prototype.slice.call(arguments));
        $anchorScroll();
        return retval;
      };
    };
    wrap('pushState');
    wrap('replaceState');
    /*========================================================================
     * back button history fucntionality
     *======================================================================*/
    $rootScope.$on('$locationChangeSuccess', function () {
      TimeOutService.checkForTimeOut();
      $timeout(ScrollToService.idOrName, 1000);
      //this is how your track of the navigation history
      $rootScope.history.push($location.$$path);
      $rootScope.actualLocation = $location.path();

      // For chat now
      setTimeout(function (){
        if(window.lpTag){
          lpTag.newPage(window.location.href, {
            section: [],
            sdes: [],
            taglets: {
            }
          });
        }
      },100);
    });

    $rootScope.$watch(function () {
      return $location.path();
    }, function (newLocation, oldLocation) {
      if ($rootScope.actualLocation === newLocation) {
        // add code here that needs to fire on back button
      }
    });

    $rootScope.$on('$locationChangeStart', function(event, newUrl, oldUrl, newState, oldState){
      const urlParams = new URLSearchParams(window.location.search);
      const newParams = new URLSearchParams([...urlParams].map(([key, value]) => [key.toLowerCase(), (value || '').toLowerCase()]));
      const disableSSO = newParams.get('disablesso') === 'true';
      if(!$cookies.get("SSOCookie") && domainAbbr !== 'mpp' && domainAbbr !== 'ded' && domainAbbr !== 'frd' && !disableSSO){
        var apiFactory = $injector.get('apiFactory');
        apiFactory.getSsoUrl(newUrl).then(function (response) {
          $window.location.href = response.data;
        });
      } else {
        $rootScope.hasSSOCookie = true;
      }
    })

    /*if needs to change on start of state change */
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, current, previous) {
      TimeOutService.setLastDigestRun();

      //console.log("stateChangeStart from: " + $state.current.name + " : " + fromState.url + " > isAuth: " + AuthenticationService.isAuthenticated() + " : " + toState.authenticate + " : to : " + toState.url);
      $rootScope.currentName = $state.current.name;
      $rootScope.fromState = fromState;

      //Remove messages when navigate away from index.
      if(fromState.url === '/'){
          if($rootScope.externalMessage){
            delete $rootScope.externalMessage;
          }
      }

      if (!$state.current.name) {
        AuthenticationService.checkAuthenticated();
        ProgramInfoService.checkProgramExists();
        VarientService.checkVarientExists();
        SetLiveSwapService.checkLSBrandExists();
      }

      if ($rootScope.accountAudit === true) {
        if (toState.name !== 'account-audit' && toState.name !== 'address-edit') {
          event.preventDefault();
        }
      }
      if (toState.authenticate && !AuthenticationService.isAuthenticated()) {
        var GCPath = vppConfig.globalConnectSignIn[environment];
        event.preventDefault();
        // set returnto URL after Sign-in
        $rootScope.returnToState = toState.name;
        if(domainAbbr === 'ded'){
          var apiFactory = $injector.get('apiFactory');
          apiFactory.gcVerify().then(function successGCSignIn(response){
            if(response.data.url != null){
              var date = new Date();
              var expirationDate = new Date(date.setMonth(date.getMonth()+6));
              $cookies.put('createAccountDirect', false, {expires: expirationDate});

              $window.location.href = response.data.url;
            }else{
              $location.path("/saml/login/" + response.data.accountId);
            }
          }, function errorCallback(response){
            console.log(response.data.errors);
            $scope.serverError = response.data.errors;
            // called asynchronously if an error occurs
            // or server returns response with an error status.
          });
        } else {
          if (toState.name == "view-auth"){
            if(domainAbbr === 'mpp' || domainAbbr === 'frd'){
              $state.transitionTo('sign-in');
            } else {
              $state.transitionTo('sign-in-notice');
            }

          } else {
            $state.transitionTo('index');

          }

        }

        // clears returnToState if user navigates away after redirect
      } else if ($rootScope.returnToState) {
        delete $rootScope.returnToState;
      }


      //OLD AccountService is not created yet, because the Services are created after .run,
      //so the way to validate if the user is logged at this stage is to validate directly with the localStorage variable
      /*
       if (toState.authenticate && (window.localStorage['accountId'] === '0' || window.localStorage['accountId'] === undefined)) {
       console.log("old IS Auth Bounce ME ~ ");
       event.preventDefault(); // stop current execution
       $rootScope.returnToState = toState.url;
       $rootScope.returnToStateParams = toParams.Id;
       $state.transitionTo('sign-in'); // go to login
       }*/

    });

    /*if needs to change on successful state change */
    $rootScope.$on('$stateChangeSuccess', function (event, to, toState, toParams, from, fromState, fromParams, on) {
      // if page has a Sub Nav in ui-view - true/false
      PageInfoService.GetPageInfo(function () {
        $rootScope.metaDescription = $rootScope.pageInfoContainer[to.name] ?  $rootScope.pageInfoContainer[to.name].metaDescription : "";
        $rootScope.pageTitle = $rootScope.pageInfoContainer[to.name] ? $rootScope.pageInfoContainer[to.name].pageTitle : "";
        $rootScope.site_Name = $rootScope.pageInfoContainer[to.name] ? $rootScope.pageInfoContainer[to.name].site_Name : "";
        $rootScope.logoImage = $rootScope.pageInfoContainer[to.name] ? $rootScope.pageInfoContainer[to.name].logoImage : "";
      });
      $rootScope.hasSubNav = ((to.views.subNav) ? true : false);
      $rootScope.pageID = $state.current.pageID;
      $rootScope.routePath = $location.path();
      $rootScope.canonical = $state.current.canonical;
      $rootScope.title = vppConfig.siteNames[vppConfig.folderPath];
      $rootScope.serverInstance = ServerNodeStore.getNodeInstance();


     for(var key  in to.views){
      var subNavInParent = 'subNav@';
      var viewItem = to.views[key];
      if(key === subNavInParent){
        $rootScope.hasSubNav = true;
      }

     }

      var programCode1 = $state.current.programCode;
      var programCode2;
      var programCode;

      // DTM Tracking Values
      DTMTrackerService.updatePageLoadData('url', $location.absUrl());
      DTMTrackerService.updatePageLoadData('seoStrategyPageName', $state.current.pageTitle);
      DTMTrackerService.updatePageLoadData('siteSectionsLevel1', $state.current.name);
      DTMTrackerService.updatePageLoadData('pageName', $state.current.name);
      DTMTrackerService.updatePageLoadData('siteName', 'GM ' + vppConfig.siteNames[vppConfig.folderPath]);
      //$window.digitalData.pageInfo.siteName = $rootScope.title + " | " + $state.current.name;

      if (localStorage.getItem("vppDataProgram") !== null) {
        programCode2 = ProgramInfoService.getProgramCode();
      }
      if (AuthenticationService.isAuthenticated()) {
        DTMTrackerService.updatePageLoadData('userProfileStateAuthentication', 'logged');
      } else {
        DTMTrackerService.updatePageLoadData('userProfileStateAuthentication', 'public');
      }
      if (programCode1) {
        programCode = programCode1;
      } else if (programCode2) {
        programCode = programCode2;
      } else {
        programCode = null;
      }
      if (programCode) {
        DTMTrackerService.updatePageLoadData('programCode', programCode);
      }
      _satellite.track('page-load');

      //set google and bing verification codes
      switch (domainAbbr) {
      case 'mpp':
        $rootScope.bingVer = '05E0452BB17B38D918F550A9FE7E652B';
        $rootScope.googleVer = 'r7B2yeXBNsrNZnaFQjjTHOAkRaBARw8Iny-8_uxmcyM';
        break;
      case 'cgp':
        $rootScope.bingVer = '05E0452BB17B38D918F550A9FE7E652B';
        $rootScope.googleVer = 'vZSEWrv8Ka0wv558FuEwm5AWuXhepjgLJbppTyjcFnU';
        break;
      case 'sup':
        $rootScope.bingVer = '05E0452BB17B38D918F550A9FE7E652B';
        $rootScope.googleVer = 'TXAh4BRx6hsEecz4VkJM1pKfJA3w2628K60KaiEMh3M';
        break;
      case 'gmed':
        $rootScope.bingVer = '05E0452BB17B38D918F550A9FE7E652B';
        $rootScope.googleVer = '327jZO-eOriJRWAl2TlG44PXansPycFlRSZetCN7pfU';
        break;
      default:
        $rootScope.bingVer = null;
        $rootScope.googleVer = null;
      }


    });

  }]);
